<template>
  <div class="box">
    <div class="loading-spinner-outer" v-if="loading">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
      </div>
    </div>
    <div class="box-content">
      <div class="flex-2xs mb-3 justify-end">
          <div class="pr-3-2xs pb-1 pb-0-2xs">
            <a class="btn-primary" href="/add-staff">
              Add New
            </a>
          </div>
          <div class="pr-3-2xs pb-1 pb-0-2xs">
            <select class="form-control" v-model="user_type_filter">
              <option value="" v-if="user_type_filter === ''">Filter ...</option>
              <option value="" v-else> Clear Filter</option>
              <option value="2">Staff</option>
              <option value="1">Admin</option>
              <option value="5" v-if="logged_in_user.isSuperUser">Super User</option>
            </select>
          </div>
          <div>
            <input type="text" placeholder="Search" class="form-control" v-model="search_query">
          </div>
      </div>
      <template v-if="!loading && total_count > 0">
        <table class="table_list">
          <thead>
          <tr>
            <th>Date Added</th>
            <th>Name</th>
            <th>Email</th>
            <th>User Level</th>
            <th></th>
              <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(staff, index) in users">
            <td>{{ staff.formatted_created_at }}</td>
            <td>{{ staff.name }}</td>
            <td>{{ staff.email }}</td>
            <td>{{ staff.user_type.label }}</td>
              <td class="td_delete">
                  <a @click="deleteStaff(staff.id)" class="txt-danger cursor-pointer">
                      <i class="fa fa-trash"></i>
                  </a>
              </td>
              <td class="td_view">
                  <a :href='"/manage-staff/"+staff.id' class="txt-primary">
                      <i class="fa fa-eye"></i>
                  </a>
              </td>
          </tr>
          </tbody>
        </table>
        <template>
          <div class="pagination-bar wrapper mb-3 mt-3">
            <div class="row">
              <div class="col">
                <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                    class="fa fa-caret-left"></i></a>
                <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                   class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
              </div>
              <div class="col align-right">
                <div class="mt-1 mb-1">
                  {{ total_count }} results found
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <template v-if="!loading && total_count === 0">
        <strong>
          No Results Found
        </strong>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    if(window.location.hash) {
      this.current_page = window.location.hash.substring(1);
    }
    this.loadUsers();
  },
  props: [
    'logged_in_user',
  ],
  data() {
    return {
      loading: true,
      users: [],
      search_query: '',
      current_page: 1,
      user_type_filter: '',
      total_count: 0,
      total_pages: 0,
      limit: 20,
    }
  },
  methods: {
    loadUsers: _.debounce(function () {
      axios.post('/getStaff', {
        page_number: this.current_page,
        search_query: this.search_query,
        user_type_filter: this.user_type_filter,
        limit: this.limit,
      }).then((response) => {
        this.users = response.data.data;
        this.total_count = response.data.total;
        this.total_pages = response.data.last_page;
        this.loading = false;
      });
    }, 250),
    prevPage() {
      this.current_page = this.current_page - 1;
      this.setPageHash();
      this.loadUsers();
    },
    nextPage() {
      this.current_page = this.current_page + 1;
      this.setPageHash();
      this.loadUsers();
    },
    deleteStaff(staff_id) {
      Swal.fire({
        title: 'Are you sure you want to remove this staff member?',
        text: 'This action cannot be undone.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
      }).then((result) => {
        if (result.isConfirmed) {
          axios.post('/deleteStaff', {
            staff_id: staff_id,
          }).then((response) => {
            this.current_page = 1;
            this.setPageHash();
            this.loadUsers();
            Swal.fire({
              title: 'Staff Member Deleted',
              icon: 'success',
            });
          });
        }
      });
    },
    setPageHash() {
      window.location = `#${this.current_page}`;
    }
  },
  watch: {
    search_query() {
      this.current_page = 1;
      this.setPageHash();
      this.loadUsers();
    },
    user_type_filter() {
      this.current_page = 1;
      this.setPageHash();
      this.loadUsers();
    },
  },
};
</script>
